import { useQueryStates } from 'nuqs';
import { loggerStreamSearchParsers } from '../../helpers/logger-stream-params';

/** URL params shape (first element of useLoggerParams return tuple). */
export type LoggerParams = ReturnType<typeof useLoggerParams>[0];

/** Logger params when range is present (from and to are set). */
export type LoggerParamsWithRange = Omit<LoggerParams, 'from' | 'to'> & {
  from: number;
  to: number;
};

/**
 * URL search params for the logger stream screen.
 * - cursor: optional timestamp; used for navigation (read from URL, not written by normal cursor moves).
 * - selection: optional "from,to" (comma-separated timestamps); positions focus at selection start (independent of range).
 * - from / to: user range; written only when user sets range via datepicker/controls.
 * Focus (zoom/pan) is internal and never synced to URL.
 */
export function useLoggerParams() {
  return useQueryStates(loggerStreamSearchParsers, {
    history: 'push',
    shallow: false,
  });
}
